import { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';

export function useSupabase(fetchFn, dependencies = []) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await fetchFn();
      setData(result);
      return result;
    } catch (err) {
      setError(err.message);
      toast.error(`Failed to fetch data: ${err.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  }, [fetchFn]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, ...dependencies]);

  return { 
    data, 
    loading, 
    error, 
    refetch: fetchData 
  };
}